import { CloudimageFaceCropPipe } from "@aifs-shared/pipe/cloudimage.pipe";
import { UserService } from "@aifs-shared/user/user.service";

import { Component, computed, EventEmitter, inject, Input, Output } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { AccountMenuComponent } from "./account-menu.component";
import { CFModalButton } from "@ui/cf-modal/cf-modal.component";
import { CFButtonType } from "@ui/cf-button/cf-button.component";
import { UiModalService } from "@ui/ui-modal.service";
import { TrackerService } from "@aifs-shared/tracker/tracker.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { User } from "@aifs-shared/user/user";
import { DocumentUploadChange, DocumentUploadChangeType, UploadService, UploadsForTypeResponse } from "@aifs-shared/upload/upload.service";
import { UploadedFile } from "@aifs-shared/upload/uploaded-file";
import { DocumentType } from "@aifs-shared/upload/document-type";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [CloudimageFaceCropPipe, RouterLink, AccountMenuComponent],
})
export class NavbarComponent {
    @Input() showLogo = false;
    private userService = inject(UserService);
    private tracker = inject(TrackerService);
    private modalService = inject(UiModalService);
    private uploadService = inject(UploadService);

    private router = inject(Router);

    @Output() onSideMenuOpened = new EventEmitter();
    @Output() onLinkClicked = new EventEmitter<string>();

    isLoggedIn = computed(() => this.userService.isLoggedIn());
    isStandardUser = computed(() => this.userService.isLoggedInWithStandardUser());
    isApplicant = computed(() => this.userService.isApplicant());

    ngOnInit() {
        if (this.userService.activeApplicationId() !== 0) {
            this.loadUploadsForType(this.userService.activeApplicationId());
        }

        // console.log(`Subscribed to user`);
        this.userSubscription = this.userService
            .userChanged
            .subscribe({
                next: (user: User | undefined) => {
                    // console.log(`USER CHANGED:`, user);
                    if (user) {
                        if (this.userService.activeApplicationId() !== 0) {
                            this.loadUploadsForType(this.userService.activeApplicationId());
                        }
                    } else {
                        this.profileImage = undefined;
                    }
                }
            });

        // Subscribe to portrait image changes
        this.profileImageSubscription = this.uploadService.uploadServiceEventStream$.subscribe({
            next: (r: DocumentUploadChange) => {
                if (r.changeType !== DocumentUploadChangeType.Ignore) {
                    const applicationId = this.userService.activeApplicationId();
                    if (applicationId) this.loadUploadsForType(applicationId);
                }
            },
            error: (error: any) => { console.error(error); }
        });
    }

    ngOnDestroy() {
        // console.log(`Navbar::destroy`);
        this.userSubscription?.unsubscribe();
        this.profileImageSubscription?.unsubscribe();
    }


    toggleSidebar(): void {
        this.onSideMenuOpened.emit();
    }

    toggleProfileMenu(): void {
        this.pmopened = !this.pmopened;
    }

    navigateTo(url: string): void {
        this.pmopened = false;
        this.onLinkClicked.emit(url);
    }

    signOut(): void {
        this.pmopened = false;

        const b: CFModalButton[] = [
            { id: 'Y', text: 'Yes', type: CFButtonType.Default },
            { id: 'N', text: 'No', type: CFButtonType.Danger },
        ];

        this.modalService
            .showModalConfirmation(
                'Sign Out',
                '<p>Are you sure you want to sign out?</p>',
                b)
            .subscribe({
                next: (r: string) => {
                    if (r === 'Y') {
                        console.log(`Signing out`);
                        this.pmopened = false;
                        this.tracker.clearTasks();
                        this.userService.logout();

                        localStorage.setItem('refresh', '1');
                        this.router.navigateByUrl("/sign-in");
                    }
                }
            });
    }

    loadUploadsForType(applicationId: number): void {
        this.uploadService
            .getUploadsForType({ applicationId: applicationId, documentType: DocumentType.Portrait })
            .subscribe({
                next: (uploadsResponse: UploadsForTypeResponse) => {
                    if (uploadsResponse.uploads.length > 0) {
                        this.uploadedFile = uploadsResponse.uploads[0];
                        this.profileImage = this.uploadedFile?.pages[0].uri;
                    } else {
                        this.uploadedFile = null;
                        this.profileImage = undefined;
                    }
                }
            });
    }

    get uploadedFile(): UploadedFile | null {
        if (this.getUploadFile && !this.__uploadedFile__.getValue()) {
            if (this.userService.isApplicant()) {
                var applicationId = this.userService.activeApplicationId();
                this.loadUploadsForType(applicationId);
                this.getUploadFile = false;
            }
        }
        return this.__uploadedFile__.getValue();
    }

    set uploadedFile(value: UploadedFile | null) {
        this.__uploadedFile__.next(value);
    }

    // Called from parent app.ts if multiple menus shouldn't be
    // open.
    public closeMenu() {
        this.pmopened = false;
    }

    profileImage?: string | undefined;

    showBackdrop = true;
    closeOnClick = true;

    pmopened = false;

    userSubscription?: Subscription;
    profileImageSubscription?: Subscription;

    __uploadedFile__ = new BehaviorSubject<UploadedFile | null>(null);
    getUploadFile = true;

}